import React, { ReactNode } from 'react'
import { Text, View } from '@react-pdf/renderer'

interface WrapperProps {
    value?: string|string[]|Record<string, any>
    title: string
    description?: string
    empty?: string
    children?: ReactNode
}

const Wrapper: React.FC<WrapperProps> = ({
    value = '',
    title,
    description,
    empty = '',
    children
}) => {
    const displayTitle = title

    //must use "!!" on any non-boolean in the JSX or the empty space it creates causes the error:
    // `Invalid '' string child outside <Text> component Error Component Stack`
    return (
        <View
            style={{
                width: '100%',
                justifyContent: 'flex-start'
            }}
        >
            <View wrap={false}>
                {!!displayTitle && (
                    <Text style={{
                        fontWeight: 'extrabold',
                        color: '#666666',
                        fontSize: 10,
                        ...(!description && { marginBottom: 4 })
                    }}>
                        {displayTitle}:
                    </Text>
                )}

                {!!description && (
                    <Text style={{
                        color: '#999999',
                        fontSize: 9,
                        fontStyle: 'italic',
                        marginBottom: 4
                    }}>
                        {description}
                    </Text>
                )}
            </View>

            {children}
        </View>
    )
}

export default Wrapper
